import { Viewer } from "cesium";
import { createUUID } from "../../utils/utils";
import { IconArrowDown } from "../../icon";
import loading from "../../assets/images/loading-roll-2.png"
import { FormFilterTreeLayer, ICustomGroup } from "./Dialog/formFilterTreeLayer";
import { LayerModelNew } from "../layerModelNew";
interface RequestLoadFilterTree {
    primitives: string[];
    customGroups: {
        key: string;
        value?: string;
        isDefault?: boolean;
    }[];
};



export class FilterTree {
    viewer: Viewer | undefined = undefined;
    dataFilter: LayerModelNew;
    formFilterTreeLayer: FormFilterTreeLayer | undefined = undefined;
    constructor(data: LayerModelNew) {
        this.dataFilter = data;
        this.formFilterTreeLayer = new FormFilterTreeLayer(
            this.dataFilter.viewer,
            this.dataFilter.containerId
        );


        if (this.formFilterTreeLayer) {
            this.formFilterTreeLayer.setClosedCallback((status: boolean, data: any) => {
                if (status) {
                    this.dataFilter.fetchLoading(true)
                    if (data.length > 0) {
                        this.handleFilterTreeLayer(data);
                    } else {
                        if (this.dataFilter.isFilterTree) {
                            this._restoreFilterTree();

                            this.dataFilter.fetchLoading(false)
                        }
                    }


                } else {
                    if (data?.action === 'closeFilter') {
                        this._restoreFilterTree();
                    } else {

                        console.log('close but not save');
                    }
                }
            });
        }
    }
    //#region _restoreFilterTree
    private _restoreFilterTree = () => {
        this.dataFilter.treeLayerModels = [...this.dataFilter.storageTreeLayerModels]
        this.dataFilter.listDisplayItem = [...this.dataFilter.storageListDisplayItem]
        this.dataFilter.isFilterTree = false
        this.dataFilter.handleDisplayItem()
        this.dataFilter.handleRefreshList()
        this.dataFilter.storageTreeLayerModels = []
        this.dataFilter.storageListDisplayItem = []
    }
    //#region handleFilterTreeLayer
    private handleFilterTreeLayer = async (data: ICustomGroup[]) => {
        const { primitiveNameFilters, treeLayerModels, } = this.dataFilter
        const result = await this._handleCallApiDataFormFilter(
            {
                primitives: primitiveNameFilters,
                customGroups: data.map(item => ({ ...item, value: "" })),
            },

        )
        if (result) {
            treeLayerModels.length = 0

            this._handleCalibrateData(result.data, data)
        }
        this.dataFilter.fetchLoading(false)

    }

    //#region _handleCallDataFormFilter
    private _handleCallApiDataFormFilter = async (data: RequestLoadFilterTree) => {
        const { token } = this.dataFilter
        const respone = await fetch("https://querytranservice1.corebim.com/api/Translate/GetIFCCustomStructure", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data)
        })
        if (respone.ok) {
            const result = await respone.json()
            return result
        } else {
            return false
        }
    }

    //#region _handleCalibrateDâta
    private _handleCalibrateData = (data: any, dataCustomGroups: ICustomGroup[]) => {
        const { treeLayerModels, handleDisplayItem, handleRefreshList } = this.dataFilter


        data.forEach((item: any) => {

            treeLayerModels.push({
                childrenObject: [],
                expand: false,
                isFolder: true,
                isLoadData: false,
                isShow: true,
                level: 0,
                objectId: createUUID(),
                parent: null,
                primitiveName: undefined,
                name: `${item.name === '_' ? 'Unknown' : (item.name === "" ? 'Other' : item.name)} (${item.totalObject})`,
                dataCustomGroups: dataCustomGroups.map(group => ({ ...group })),
                valueFilter: item.name,
                typeFilter: item.type,
                totalObject: item.totalObject,

            })

        })


        handleDisplayItem()
        handleRefreshList()
    }


    //#region _handerCallApiDetailDataFilter
    private _handerCallApiDetailDataFilter = async (dataItem: any) => {
        const { primitiveNameFilters } = this.dataFilter

        // const dataGroups = this._handleCalibrateFilterDetailData(dataItem, false)
        if (dataItem.dataCustomGroups.length !== dataItem.level + 1) {

            dataItem.dataCustomGroups[dataItem.level].value = dataItem.valueFilter
            dataItem.dataCustomGroups[dataItem.level].isDefault = dataItem.valueFilter === '_' ? true : false;
        }

        const respone = this._handleCallApiDataFormFilter(
            {
                primitives: primitiveNameFilters,
                customGroups: dataItem.dataCustomGroups
            }
        )

        return respone
    }

    //#region _handleCallApiGetObjects
    private _handleCallApiGetObjects = async (dataItem: any) => {
        const { token, primitiveNameFilters } = this.dataFilter
        // const dataGroups = this._handleCalibrateFilterDetailData(dataItem, true)
        dataItem.dataCustomGroups[dataItem.level].value = dataItem.valueFilter
        dataItem.dataCustomGroups[dataItem.level].isDefault = dataItem.valueFilter === '_' ? true : false;

        const respone = await fetch("https://querytranservice1.corebim.com/api/Translate/GetObjectInCustomStructure", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                primitives: primitiveNameFilters,
                // customGroups: [
                //     {
                //         key: dataItem.typeFilter,
                //         value: dataItem.valueFilter || '',
                //         isDefault: dataItem.valueFilter === '_' ? true : false,
                //     },
                // ]
                customGroups: dataItem.dataCustomGroups
            },
            )
        })
        if (respone.ok) {
            const result = await respone.json()
            return result
        } else {
            return false
        }

    }



    //#region _handleActionArrowForFilterDetailData
    handleActionArrowForFilterDetailData = async (currentItem: any, arrow: HTMLSpanElement) => {
        const { treeLayerModels, handleDisplayItem, handleRefreshList, handleRemoveDisplayItem } = this.dataFilter

        if (!currentItem.isLoadData && !currentItem.expand) {
            arrow.style.pointerEvents = "none";
            arrow.innerHTML = ` <img class = "dpu-loading-animation" src="${loading}" alt="Loading..." width="14" height ="14"  style="pointer-events: none;"/>`
            const isFolder = currentItem.level !== currentItem.dataCustomGroups.length - 1;
            const result = isFolder ? await this._handerCallApiDetailDataFilter(currentItem) : await this._handleCallApiGetObjects(currentItem);
            if (result) {
                const tempChildrenUsed: any[] = []
                if (isFolder) {
                    result.data.forEach((item: any) => {
                        if (item.totalObject > 0) {

                            const newItem =
                            {
                                childrenObject: [],
                                expand: false,
                                isFolder: true,
                                isLoadData: false,
                                isShow: currentItem.isShow,
                                level: currentItem.level + 1,
                                objectId: createUUID(),
                                parent: currentItem.objectId,
                                primitiveName: undefined,
                                name: `${item.name === '_' ? 'Unknown' : (item.name === "" ? 'Other' : item.name)} (${item.totalObject})`,

                                dataCustomGroups: currentItem.dataCustomGroups || [],
                                valueFilter: item.name,
                                typeFilter: item.type,
                                totalObject: item.totalObject,
                            }

                            treeLayerModels.push(newItem)
                            tempChildrenUsed.push(newItem);

                        }
                    })
                } else {
                    result.data?.forEach((item: any) => {
                        const newItem = {
                            childrenObject: [],
                            isFolder: false,
                            isLoadData: true,
                            isShow: currentItem.isShow,
                            level: currentItem.level + 1 || 1,
                            parent: currentItem.objectId,
                            primitiveName: undefined,
                            ...item
                        }
                        treeLayerModels.push(newItem)
                        tempChildrenUsed.push(newItem)

                    })
                }
                currentItem.expand = true
                currentItem.isLoadData = true

                handleDisplayItem(currentItem)
                handleRefreshList()
                // calConditionForTree()
                if (!currentItem.dataPoint) {

                    await this.computeGlobalPointAndCondition(currentItem);


                }
                currentItem.dataPoint.childrenUsed = [...tempChildrenUsed];
                this.computeChildrenUsed(currentItem);
                // if (currentItem.dataPoint.childrenUsed) {
                //     currentItem.dataPoint.childrenUsed.push(...tempChildrenUsed);

                // }


                arrow.innerHTML = IconArrowDown();

            } else {
                currentItem.expand = false
                currentItem.isLoadData = false
                arrow.innerHTML = IconArrowDown();
            }

            arrow.style.pointerEvents = "auto";
        }


        else {
            if (!currentItem.expand) {
                currentItem.expand = true

                handleDisplayItem(currentItem)
                handleRefreshList()
            } else {
                currentItem.expand = false
                handleRemoveDisplayItem(currentItem)
                handleRefreshList()
            }
        }
        arrow.style.pointerEvents = "auto";

    }

    //#region computeGlobalPointAndCondition
    computeGlobalPointAndCondition = async (dataItem: any) => {
        const { listKeyMapObject } = this.dataFilter
        dataItem.conditionIsolate = []
        dataItem.conditionShowOff = []
        const result = await this._handleCallApiGetObjects(dataItem)
        if (result) {
           
            let minPoints = [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY];
            let maxPoints = [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY];


            result.data?.forEach((item: any) => {
                if (listKeyMapObject) {
                    const objConnects = listKeyMapObject[item.objectId]?.objectConnects;
                    if (objConnects) {
                        objConnects.forEach((connect: any) => {
                            const minPoint = connect.minPoint;
                            const maxPoint = connect.maxPoint;

                            if (minPoint && maxPoint) {
                                // Cập nhật globalMinPoint
                                minPoints = minPoints.map((val, idx) => Math.min(val, minPoint[idx]));

                                // Cập nhật globalMaxPoint
                                maxPoints = maxPoints.map((val, idx) => Math.max(val, maxPoint[idx]));
                            }
                            const featureId = connect.featureId;
                            const fileName = connect.file;
                            const guid = connect.guid;
                            dataItem.conditionIsolate.push([`\${batchId}===${featureId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`, 'color("rgba(255,255,255,1)")']);
                            dataItem.conditionShowOff.push([`\${batchId}===${featureId}&&\${fileName}==='${fileName}'&&\${guid}==='${guid}'`, 'false']);
                        });
                    }
                }
            });
            dataItem.dataPoint = {
                childrenUsed: result.data,
                min: minPoints,
                max: maxPoints,
            }
        }
        else {
            return
        }
    }

    computeChildrenUsed = (currentItem: any) => {
        const { treeLayerModels } = this.dataFilter
        if (currentItem.parent) {
            const parentItem = treeLayerModels.find(item => item.objectId === currentItem.parent);
            if (parentItem) {
                parentItem.dataPoint.childrenUsed.push(...currentItem.dataPoint.childrenUsed);

                if (parentItem.parent) {
                    this.computeChildrenUsed(parentItem);
                }
            }
        }
    }


}